import p from "../VAvatar/VAvatar.js";
import s from "../VHTMLText/VHTMLText.js";
import { S as i } from "../../../Spacing-695d3b19.js";
import { defineComponent as a, resolveComponent as t, openBlock as c, createElementBlock as l, createVNode as o } from "vue";
import { _ as m } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../utils/htmlSanitizer.js";
import "../../../composables/useSpacingClass.js";
const _ = a({
  name: "VSpeechBubble",
  components: {
    VAvatar: p,
    VHTMLText: s
  },
  inheritAttrs: !1,
  props: {
    subline: {
      type: String,
      default: ""
    },
    profileImg: {
      type: String,
      default: ""
    }
  },
  setup() {
    return {
      Spacing: i
    };
  }
});
const b = { class: "hobi-speechbubble__speechbubble-wrapper tw-relative tw-flex tw-justify-between tw-items-center" };
function u(e, d, f, g, h, v) {
  const r = t("VHTMLText"), n = t("VAvatar");
  return c(), l("div", b, [
    o(r, {
      size: "m",
      "right-spacing": e.Spacing.s,
      class: "hobi-speechbubble__speechbubble-text tw-inline-block tw-bg-gray-200 tw-rounded",
      "html-text": e.subline,
      tag: "div",
      router: { handleLink: () => {
      } }
    }, null, 8, ["right-spacing", "html-text", "router"]),
    o(n, {
      imageSrc: e.profileImg,
      background: "grey-200"
    }, null, 8, ["imageSrc"])
  ]);
}
const B = /* @__PURE__ */ m(_, [["render", u], ["__scopeId", "data-v-42371331"]]);
export {
  B as default
};
